<div class="video-modal">
  <div class="modal-header">
    <button
      type="button"
      class="btn-close"
      aria-label="Close"
      (click)="closePopup()"
    ></button>
  </div>
  <div class="modal-body">
    <!--<div class="h-90">
  <iframe [src]="safeUrl"  width="100%" height="100%"></iframe>-->
    <!--<iframe [src]="url" width="100%" height="100%">
    <p>Your browser does not support iframes.</p>
  </iframe>-->
    <!--</div>-->
    
    <div id="outerContainer">
        <div class="pdf-container " >

            <pdf-viewer [src]="url"
                        [rotation]="0"
                        [original-size]="false"
                        [show-all]="true"
                        [fit-to-page]="false"
                        [zoom]="1"
                        [zoom-scale]="'page-width'"
                        [stick-to-page]="false"
                        [render-text]="true"
                        [external-link-target]="'blank'"
                        [autoresize]="true"
                        [show-borders]="false"
                        (page-rendered)="pageRendered()"
                        style="width: 100%; height: 80vh;"></pdf-viewer>
        </div>
    </div>
  </div>
</div>
